import React from 'react';
import {useSurveyContext} from "../../../context/SurveyContext";
import Checkbox from "../../Checkbox";
import InfoBox from "../InfoBox";
import {isQuestionShown} from "../../../utils/questionnaireUtils";
import Question from "./Question";

function CheckboxQuestion(props) {
    const {survey: {answers, passenger}, setAnswer} = useSurveyContext();
    const answer = answers[props.question.id] ? answers[props.question.id] : [];

    const nestedQuestions = answer.reduce(
        (items, item) => props.question.questions && props.question.questions[item] ?
            [...items, ...props.question.questions[item]?.filter(isQuestionShown(passenger))] :
            items,
        []);

    const isShown = props.question.part === props.activePart;

    const answersSort = (a, b) => props.question.options.indexOf(a) - props.question.options.indexOf(b);
    
    return (
        <div>
            <div className={isShown ? "" : "hidden"}>
                <div className="text-lg text-grey-darker">
                    {props.question.questionText}
                </div>


                {props.question.questionInfo &&
                <InfoBox
                    classes="mt-6 md:inline-block"
                    infoText={props.question.questionInfo}
                    description={props.question.infoDescription}
                />
                }


                <div className="mt-4">
                    {props.question.options.map(option =>
                        <div className="my-3" key={option}>
                            <Checkbox checked={answer.includes(option)}
                                      value={option}
                                      handleCheckboxChange={() => setAnswer(
                                          props.question.id, answer.includes(option) ?
                                              answer.filter(item => item !== option) :
                                              [...answer, option].sort(answersSort)
                                      )}>
                                {option}
                            </Checkbox>
                        </div>
                    )}
                </div>
            </div>

            {nestedQuestions &&
            <div>
                {nestedQuestions.map(question =>
                    <Question
                        key={question.id}
                        activePart={props.activePart}
                        question={question}
                    />
                )}
            </div>
            }
        </div>
    )
}

export default CheckboxQuestion;